import { render, staticRenderFns } from "./bodyCommitCard.vue?vue&type=template&id=6412a421&scoped=true"
import script from "./bodyCommitCard.vue?vue&type=script&lang=js"
export * from "./bodyCommitCard.vue?vue&type=script&lang=js"
import style0 from "./bodyCommitCard.vue?vue&type=style&index=0&id=6412a421&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6412a421",
  null
  
)

export default component.exports